import styled from 'styled-components';
import { BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 432px;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
      margin-top: ${theme.layout.spacing.centy};
  `}

  [data-testid='input-label'] {
    ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.primary[100]};
  `}
  }
`;

export const Link = styled(BodyRegularS)`
  align-self: flex-end;
  text-decoration-line: underline;
  cursor: pointer;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.deka};
    color: ${theme.colors.primary[100]};
  `}
`;

export const ApiErrorCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    margin-bottom: ${theme.layout.spacing.deka};
  `}
`;

export const InputCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
`;

export const MicrosoftButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 320px;
  height: 41px;
  background-color: #ffffff;
  border: 1px solid #8c8c8c;
  border-radius: 0;
  cursor: pointer;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #5e5e5e;
  letter-spacing: 0.1px;
  margin-top: 12px;
  padding: 0 12px;
  transition: background-color 0.1s ease;

  &:hover {
    background-color: #f3f2f1;
  }

  &:active {
    background-color: #edebe9;
  }

  svg {
    flex-shrink: 0;
  }
`;
